module.exports = __webpack_public_path__ + "img/diy-craft.178306b8.webp";